import { type Listener } from '@databases/event-bus';

import { type CoreEventBus, type CoreEventBusEvents } from '..';

type EventType = CoreEventBusEvents['bridgeDataChanged'];

export const maybeDispatchContentIdChanged = (
  eventBus: CoreEventBus
): Listener<EventType> => {
  return (event: EventType) => {
    if (event.newContentId !== event.oldContentId) {
      eventBus.dispatch('databaseContentIdChanged', null);
    }
  };
};
